import { useContext } from 'react';
import { ChatSocketContext, ChatSocketContextValue } from './ChatSocketContext';

export const useChatSocket = (): ChatSocketContextValue => {
  const ctx = useContext(ChatSocketContext);
  if (!ctx) throw new Error('useChatSocket, ChatSocketProvider içinde kullanılmalıdır');
  return ctx;
};
